import React, { MouseEvent } from "react";
import { ClearIcon } from "@mui/x-date-pickers";
import { StyledClearButton } from "./ClearButton.styled";
import { FC } from "../../../../types";

interface ClearButtonProps {
  onClear?(event: MouseEvent<HTMLButtonElement>): void;
}

export const ClearButton: FC<ClearButtonProps> = ({ onClear }) => {
  return (
    <StyledClearButton className="clearButton" onClick={onClear}>
      <ClearIcon />
    </StyledClearButton>
  );
};
